import React from 'react'
import Divider from '@mui/material/Divider'
import { useNavigate } from 'react-router'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
// import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
// import FacebookIcon from '@mui/icons-material/Facebook'
// import TwitterIcon from '@mui/icons-material/Twitter'
// import InstagramIcon from '@mui/icons-material/Instagram'

const Footer = () => {
  const navigate = useNavigate()

  return (
    <>
      <Grid
        item
        xs={12}
        display={'flex'}
        justifyContent={'space-between'}
        // alignItems={'flex-start'}
        flexDirection={{ xs: 'column', md: 'row' }}
        marginBottom={3}
      >
        <Box
        width={{ xs: '100%', md: '33%' }}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          flexDirection={'column'}
        >
          <Box
            component="button"
            onClick={() => navigate('/')}
            width={80}
            style={{ all: 'unset', cursor: 'pointer' }}
          >
            <Box
              component={'img'}
              src="/images/drivolo-logo.png"
              height="13vh"
            />
          </Box>
          <br />
          <Box>
            <Typography variant="h5" color="text.secondary">
              Drivolo Drive Smart Private Limited
            </Typography>
          </Box>
        </Box>
        <Box
          width={{ xs: '100%', md: '33%' }}
          marginTop={{ xs: 3, md: 0 }}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          flexDirection={'column'}
        >
          <Typography
            variant="h4"
            data-aos={'fade-up'}
            gutterBottom
            sx={{
              fontWeight: 700,
              textAlign: 'left',
            }}
          >
            Quick Links
          </Typography>
          <Box marginTop={1}>
            <Link
              underline="none"
              component="button"
              onClick={() => navigate('/about')}
              color="text.primary"
              variant={'subtitle2'}
            >
              About
            </Link>
          </Box>
          <Box marginTop={1}>
            <Link
              underline="none"
              component="button"
              onClick={() => navigate('/pricing')}
              color="text.primary"
              variant={'subtitle2'}
            >
              Pricing
            </Link>
          </Box>
          <Box marginTop={1}>
            <Link
              underline="none"
              component="button"
              onClick={() => navigate('/contact')}
              color="text.primary"
              variant={'subtitle2'}
            >
              Contact
            </Link>
          </Box>
          <Box marginTop={1}>
            <Link
              underline="none"
              component="button"
              onClick={() => navigate('/privacy-policy')}
              color="text.primary"
              variant={'subtitle2'}
            >
              Privacy Policy
            </Link>
          </Box>
          <Box marginTop={1}>
            <Link
              underline="none"
              component="button"
              onClick={() => navigate('/terms-and-conditions')}
              color="text.primary"
              variant={'subtitle2'}
            >
              Terms and Conditions
            </Link>
          </Box>
        </Box>
        <Box
          width={{ xs: '100%', md: '33%' }}
          marginTop={{ xs: 3, md: 0 }}
          display={'flex'}
          justifyContent={'flex-start'}
          alignItems={'center'}
          flexDirection={'column'}
        >
          <Typography
            variant="h4"
            data-aos={'fade-up'}
            gutterBottom
            sx={{
              fontWeight: 700,
            }}
          >
            Address
          </Typography>
          <Typography
            variant="p"
            data-aos={'fade-up'}
            sx={{
              fontWeight: 500,
              textAlign: 'center',
            }}
          >
            Drivolo Drive Smart Private Limited
            <br />
            7-1-B31/A, ERO 50, Sanath Nagar,
            <br />
            Hyderabad, Telangana, India
            <br />
            500018
          </Typography>
        </Box>
      </Grid>
      <Divider />

      <Typography
        marginTop={3}
        align={'center'}
        variant={'subtitle2'}
        color="text.secondary"
      >
        &copy; Drivolo Drive Smart Private Limited. {new Date().getFullYear()}.
        All rights reserved
      </Typography>
    </>
  )
}

export default Footer
